module.exports = __webpack_public_path__ + "static/media/0022_IMG_LES_MURS_BIBOND_IMPRESSION_BRIQUE.c206e8f2.webp";